import { render, staticRenderFns } from "./ForogotPassword.vue?vue&type=template&id=1405c93f"
import script from "./ForogotPassword.vue?vue&type=script&lang=js"
export * from "./ForogotPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports